import { useSelector } from 'react-redux'
import {
  setDialogAction,
  uiGlobalSelector,
} from '@/state/ui/global/slices/index.slices'
import { authSelector } from '@/state/auth/slices/index.slices'

import { useAppDispatch } from '@/state'
import { DialogModel } from '@/state/ui/global/models'

export const useWalletsDialog = () => {
  const dispatch = useAppDispatch()

  const { formMode, dialog } = useSelector(uiGlobalSelector)

  const { userSession } = useSelector(authSelector)

  const toggleDialog = (payload: boolean | DialogModel) => {
    dispatch(
      setDialogAction(
        typeof payload === 'boolean' ? { open: payload } : payload,
      ),
    )
  }

  return {
    dialog,
    toggleDialog,
    formMode,
    userSession,
  }
}
